export var AI_ANSWER_STATUS;
(function (AI_ANSWER_STATUS) {
    AI_ANSWER_STATUS["PROCESSING"] = "PROCESSING";
    AI_ANSWER_STATUS["DONE"] = "DONE";
    AI_ANSWER_STATUS["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    AI_ANSWER_STATUS["REVIEWED"] = "REVIEWED";
    AI_ANSWER_STATUS["USER_CHANGED"] = "USER_CHANGED";
})(AI_ANSWER_STATUS || (AI_ANSWER_STATUS = {}));
export var AI_GENERATION_STATUS;
(function (AI_GENERATION_STATUS) {
    AI_GENERATION_STATUS["PROCESSING"] = "PROCESSING";
    AI_GENERATION_STATUS["DONE"] = "DONE";
    AI_GENERATION_STATUS["ERROR"] = "ERROR";
})(AI_GENERATION_STATUS || (AI_GENERATION_STATUS = {}));
export var AI_PROVIDER;
(function (AI_PROVIDER) {
    AI_PROVIDER["AZURE"] = "AZURE";
    AI_PROVIDER["GOOGLE_CLOUD"] = "GOOGLE_CLOUD";
    AI_PROVIDER["AWS_BEDROCK"] = "AWS_BEDROCK";
})(AI_PROVIDER || (AI_PROVIDER = {}));
export var AI_SERVICE_AZURE;
(function (AI_SERVICE_AZURE) {
    AI_SERVICE_AZURE["OPEN_AI"] = "OPEN_AI";
    AI_SERVICE_AZURE["SPEECH_SERVICE"] = "SPEECH_SERVICE";
})(AI_SERVICE_AZURE || (AI_SERVICE_AZURE = {}));
export var AI_SERVICE_GOOGLE_CLOUD;
(function (AI_SERVICE_GOOGLE_CLOUD) {
    AI_SERVICE_GOOGLE_CLOUD["GEMINI_API"] = "GEMINI_API";
})(AI_SERVICE_GOOGLE_CLOUD || (AI_SERVICE_GOOGLE_CLOUD = {}));
export var AI_SERVICE_AWS_BEDROCK;
(function (AI_SERVICE_AWS_BEDROCK) {
    AI_SERVICE_AWS_BEDROCK["ANTHROPIC"] = "ANTHROPIC";
    AI_SERVICE_AWS_BEDROCK["OPENAI"] = "OPENAI";
})(AI_SERVICE_AWS_BEDROCK || (AI_SERVICE_AWS_BEDROCK = {}));
export var AI_MODEL_AZURE;
(function (AI_MODEL_AZURE) {
    AI_MODEL_AZURE["GPT_4_1_MINI"] = "gpt-4.1-mini";
    AI_MODEL_AZURE["GPT_4_1_NANO"] = "gpt-4.1-nano";
})(AI_MODEL_AZURE || (AI_MODEL_AZURE = {}));
export var AI_MODEL_AWS_BEDROCK_ANTHROPIC;
(function (AI_MODEL_AWS_BEDROCK_ANTHROPIC) {
    AI_MODEL_AWS_BEDROCK_ANTHROPIC["CLAUDE_HAIKU_5_5"] = "au.anthropic.claude-haiku-5-5";
    AI_MODEL_AWS_BEDROCK_ANTHROPIC["CLAUDE_SONNET_5_5"] = "au.anthropic.claude-sonnet-5-5";
    AI_MODEL_AWS_BEDROCK_ANTHROPIC["CLAUDE_OPUS_5_5"] = "au.anthropic.claude-opus-5-5";
})(AI_MODEL_AWS_BEDROCK_ANTHROPIC || (AI_MODEL_AWS_BEDROCK_ANTHROPIC = {}));
export var AI_MODEL_AWS_BEDROCK_OPENAI;
(function (AI_MODEL_AWS_BEDROCK_OPENAI) {
    AI_MODEL_AWS_BEDROCK_OPENAI["GPT_OSS_120B"] = "openai.gpt-oss-120b-1:0";
})(AI_MODEL_AWS_BEDROCK_OPENAI || (AI_MODEL_AWS_BEDROCK_OPENAI = {}));
export var AI_MODEL_AZURE_SPEECH_TO_TEXT;
(function (AI_MODEL_AZURE_SPEECH_TO_TEXT) {
    AI_MODEL_AZURE_SPEECH_TO_TEXT["REAL_TIME_TRANSCRIPTION"] = "real-time-transcription";
    AI_MODEL_AZURE_SPEECH_TO_TEXT["FAST_TRANSCRIPTION"] = "fast-transcription";
    AI_MODEL_AZURE_SPEECH_TO_TEXT["BATCH_TRANSCRIPTION"] = "batch-transcription";
})(AI_MODEL_AZURE_SPEECH_TO_TEXT || (AI_MODEL_AZURE_SPEECH_TO_TEXT = {}));
export var AI_MODEL_GOOGLE_CLOUD;
(function (AI_MODEL_GOOGLE_CLOUD) {
    AI_MODEL_GOOGLE_CLOUD["GEMINI_2_5_FLASH"] = "gemini-2.5-flash";
})(AI_MODEL_GOOGLE_CLOUD || (AI_MODEL_GOOGLE_CLOUD = {}));
export var AI_COST_UNIT_TYPE;
(function (AI_COST_UNIT_TYPE) {
    AI_COST_UNIT_TYPE["TOKEN"] = "TOKEN";
    AI_COST_UNIT_TYPE["TIME"] = "TIME";
    AI_COST_UNIT_TYPE["REQUEST"] = "REQUEST";
})(AI_COST_UNIT_TYPE || (AI_COST_UNIT_TYPE = {}));
/**
 * Pricing for AI models hosted on Azure. Prices are in USD.
 * https://azure.microsoft.com/en-us/pricing/details/azure-openai
 */
export const AZURE_PRICING_PER_MODEL = {
    // USD based pricing for `GPT-4.1-mini-2025-04-14 Global`
    [AI_MODEL_AZURE.GPT_4_1_MINI]: {
        inputRate: 0.4,
        cachedInputRate: 0.1,
        outputRate: 1.6,
    },
    [AI_MODEL_AZURE.GPT_4_1_NANO]: {
        inputRate: 0.1,
        cachedInputRate: 0.03,
        outputRate: 0.4,
    },
};
/**
 * Pricing for Speech to Text AI models used by Azure Speech Service. Prices are in USD.
 * Note that Speech to Text uses per second billing even if the rates are per hour.
 * https://azure.microsoft.com/en-us/pricing/details/speech/
 */
export const AZURE_SPEECH_TO_TEXT_PRICING_PER_MODEL = {
    [AI_MODEL_AZURE_SPEECH_TO_TEXT.REAL_TIME_TRANSCRIPTION]: {
        hourlyRate: 1,
    },
    [AI_MODEL_AZURE_SPEECH_TO_TEXT.FAST_TRANSCRIPTION]: {
        hourlyRate: 0.36,
    },
    [AI_MODEL_AZURE_SPEECH_TO_TEXT.BATCH_TRANSCRIPTION]: {
        hourlyRate: 0.18,
    },
};
export const MIN_SCORE_THRESHOLDS = {
    minDataScore: 10,
    minConfidenceScore: 10,
    minReviewScore: 70,
};
/**
 * Below this many questions, relevance-based grouping costs more overhead than it saves.
 */
export const GROUP_QUESTIONS_MIN = 8;
/**
 * System-prompt versioning for AI survey generation.
 * The version is stored on a survey type's SurveyJS JSON via a survey-level serializer property,
 * pinning each SurveyTypeVersion to a specific system prompt so updating the prompt doesn't alter existing survey types.
 */
export const AI_SYSTEM_PROMPT_VERSION_PROPERTY = "aiSystemPromptVersion";
/**
 * Version applied to survey type versions that predate this feature (no property set).
 * Reading an absent property resolves to this via the serializer default.
 */
export const FIRST_AI_SYSTEM_PROMPT_VERSION = 1;
/**
 * Version applied to newly created survey types and new versions of a survey type.
 * Bump this when introducing a new system prompt.
 */
export const LATEST_AI_SYSTEM_PROMPT_VERSION = 2;
export const AI_SYSTEM_PROMPT_VERSION_CHOICES = [
    { value: 1, text: "Version 1" },
    { value: 2, text: "Version 2 - Latest" },
];
export const AWS_BEDROCK_ANTHROPIC_PRICING_PER_MODEL = {
    [AI_MODEL_AWS_BEDROCK_ANTHROPIC.CLAUDE_HAIKU_5_5]: {
        inputRate: 0.11,
        cachedInputReadRate: 0.011,
        outputRate: 0.55,
        longContext: {
            aboveInputTokens: 100_000,
            inputRate: 0.55,
            cachedInputReadRate: 0.055,
            outputRate: 2.75,
        },
    },
    [AI_MODEL_AWS_BEDROCK_ANTHROPIC.CLAUDE_SONNET_5_5]: {
        inputRate: 2.2,
        cachedInputReadRate: 0.22,
        outputRate: 11,
    },
    [AI_MODEL_AWS_BEDROCK_ANTHROPIC.CLAUDE_OPUS_5_5]: {
        inputRate: 4.4,
        cachedInputReadRate: 0.22,
        outputRate: 22,
    },
};
/**
 * Pricing for AI models available via Gemini API. Prices are in USD.
 * https://ai.google.dev/gemini-api/docs/pricing
 */
export const GOOGLE_CLOUD_PRICING_PER_MODEL = {
    // USD based pricing - https://ai.google.dev/gemini-api/docs/pricing#gemini-2.5-flash
    [AI_MODEL_GOOGLE_CLOUD.GEMINI_2_5_FLASH]: {
        inputRateTextOrImage: 0.3,
        inputRateAudio: 1.0,
        outputRate: 2.5,
    },
};
export const AI_FILE_EXTENSIONS = [
    "pdf",
    "png",
    "jpg",
    "jpeg",
    "gif",
    "webp",
    "docx",
    "pptx",
    "xlsx",
    "odt",
    "odp",
    "ods",
    "rtf",
    "csv",
    "md",
    "html",
    "htm",
    "txt",
];
export const RECENT_RESPONDENT_DOCUMENTS_QUERY = {
    fileExtensions: AI_FILE_EXTENSIONS,
    maxFileSize: 5 * 1024 * 1024,
    sortField: "createdAt",
    sortDirection: "desc",
    pageSize: 10,
};
//# sourceMappingURL=ai.js.map